'use strict';

var {maskValues} = require('../masks');

module.exports = {
    billingPhone: function (input) {
        return maskValues().phone(input);
    },
    shippingPhone: function (input) {
        return maskValues().phone(input);
    },
    accountPhone: function (input) {
        return maskValues().phone(input);
    },
    refresh: function (_, core) {
        core.refresh();
    },
    // Shared bridges
    moneyFormater: function (input, core) {
        var siteLocale = core.getMutable('siteLocale');
        var siteCurrency = core.getMutable('siteCurrency');
        siteLocale = siteLocale.replace('_', '-');

        var localeMoney = input.toLocaleString(siteLocale, { minimumFractionDigits: 2, style: 'currency', currency: siteCurrency });
        return localeMoney + ' ' + siteCurrency;
    },
    formatFrenchDate: function (input, core) {
        var trimmedInput = $(`<div>${input || ''}</div>`).text().trim();
        var date = new Date(trimmedInput);
        var siteLocale = core.getMutable('siteLocale');
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        var time = date.toLocaleTimeString('en-US', {timeStyle: 'short'});

        if (siteLocale === 'fr_CA') {
            return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year} ${time}`;
        } else {
            return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year} ${time}`;
        }
    }
};
